import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { queryKeys } from "../queryKeys";

/**
 * Semantic refreshes for hub events that carry no in-app mutation: the data
 * changed on the backend (DocuSeal webhook) or the whole portal context
 * switched (profile change), so presentation asks for a refresh by name
 * instead of touching query keys.
 */

/** After returning from the DocuSeal signing redirect. Note: the backend is
 * updated by DocuSeal's webhook, which may land after the redirect — see
 * issue #419 for the poll/retry follow-up. */
export function useRefreshAfterSigning() {
  const queryClient = useQueryClient();
  return useCallback(() => {
    queryClient.invalidateQueries({ queryKey: queryKeys.hub.pendingActions() });
    queryClient.invalidateQueries({ queryKey: queryKeys.hub.dashboard() });
  }, [queryClient]);
}

/** After switching the selected hub profile: every hub query is stale. */
export function useRefreshHubPortal() {
  const queryClient = useQueryClient();
  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: queryKeys.hub.all }),
    [queryClient],
  );
}
